import type { NextPage } from 'next'
import { useEffect, useState } from 'react'
import NextError from 'next/error'
import { useRouter } from 'next/router'
import * as Sentry from '@sentry/react'

const Fallback: NextPage = () => {
  const [isError, setIsError] = useState(false)

  const router = useRouter()

  const replacePath = async () => {
    try {
      await router.replace(router.asPath)
    } catch (error: unknown) {
      // 存在しないURLから同じURLに再度ナビゲートのエラーであるかをチェック
      // see: https://github.com/vercel/next.js/blob/v12.3.1/packages/next/shared/lib/router/router.ts#L799
      const isExpectedError =
        error instanceof Error &&
        error.message.includes(
          'Invariant: attempted to hard navigate to the same URL',
        )

      // 予期しないエラーの場合はSentryへ通知
      if (!isExpectedError) Sentry.captureException(error)

      // 存在しないURLなので404ページへリダイレクト
      router.replace('404')
    }
  }

  useEffect(() => {
    if (router.asPath === '/fallback' || router.asPath === '/fallback/') {
      setIsError(true)
      return
    }

    replacePath()
  }, [])

  return <>{isError && <NextError statusCode={404} />}</>
}

export default Fallback
